type AsyncFn<T = void> = (...args: any[]) => Promise<T>;

const debounceExecution = <T>(func: AsyncFn<T>, delay: number) => {
    let timeout;

    return (...args: any[]): Promise<T> => {
        clearTimeout(timeout);

        return new Promise((resolve, reject) => {
            timeout = setTimeout(async () => {
                try {
                    const result = await func(...args);
                    resolve(result);
                } catch (error) {
                    reject(error);
                }
            }, delay);
        });
    };
};

export default debounceExecution;